// import React, { useState, useEffect } from "react";
// import "./Hero.css";

// function Hero() {
//   const taglines = [
//     "Leading Commercial HVAC, Plumbing and Electrical Subcontractor",
//     "Building Florida’s Future Since 2008",
//     "Trusted by 100+ Completed Projects",
//     "Quality • Safety • Reliability",
//   ];

//   const [currentTaglineIndex, setCurrentTaglineIndex] = useState(0);

//   // 🔄 Tagline rotation
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentTaglineIndex((prevIndex) =>
//         prevIndex === taglines.length - 1 ? 0 : prevIndex + 1
//       );
//     }, 4000);
//     return () => clearInterval(interval);
//   }, [taglines.length]);

//   return (
//     <div className="hero">
//       {/* 🎬 Background video */}
//       <video
//         className="hero-video"
//         autoPlay
//         loop
//         muted
//         playsInline
//       >
//         <source src="/Videos/FB_Wynwood.mp4" type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>

//       {/* ✨ Text overlay */}
//       <div className="hero-content hero-box">
//         <h1 key={currentTaglineIndex} className="tagline fade">
//           {taglines[currentTaglineIndex]}
//         </h1>
//       </div>
//     </div>
//   );
// }

// export default Hero;

//old Hero.js (for old home page)
import React, { useState, useEffect } from "react";
import "./Hero.css";

function Hero() {
  const images = [
    "/Images/Projects/FB_Wynwood.jpg",
    "/Images/Projects/Fire_Station_87.jpg",
    "/Images/Projects/Aloft.jpg",
    "/Images/Projects/Element_34.jpg",
    "/Images/Projects/Fire_Station_88.jpg",
    
  ];

  const taglines = [
    "Leading Commercial HVAC, Plumbing and Electrical Subcontractor",
    "Building Florida’s Future Since 2008",
    "Trusted by 75+ Completed Projects",
    "Quality • Safety • Reliability",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentTaglineIndex, setCurrentTaglineIndex] = useState(0);

  // 🔄 Background rotation
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // slower: every 4s
    return () => clearInterval(interval);
  }, [images.length]);

  // 🔄 Tagline rotation
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTaglineIndex((prevIndex) =>
        prevIndex === taglines.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // every 3s
    return () => clearInterval(interval);
  }, [taglines.length]);

  // Hero.js (keep your imports, images[], taglines[], useEffects, etc.)
return (
  <div
    className="hero"
    style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
  >
    <div className="hero-content hero-box">
      <h1 key={currentTaglineIndex} className="tagline fade">
        {taglines[currentTaglineIndex]}
      </h1>
      {/* Optional supporting line – delete if you don't want it */}
      {/* <p className="subtext">Electrical • HVAC • Plumbing</p> */}
    </div>
  </div>
);
}


export default Hero;
